import type { TFunction } from "i18next";
import type { U2000DeleteHandlersReturn } from "../../../u2000Core/hooks/handler/U2000UseDeleteHandlers";
import U2000DeleteRecordDialog from "../../../u2000Core/components/dialog/U2000DeleteRecordDialog";

// Typage des props du composant
interface U2101LogicalUnitDeleteDlgProps {
  handleDelete: U2000DeleteHandlersReturn;
  t: TFunction;
  NS: string;
}

function U2101LogicalUnitDeleteDlg({ handleDelete, t, NS }: U2101LogicalUnitDeleteDlgProps) {
  // Plus besoin de helpers custom, U2000CheckBoxArray gère tout

  if (!handleDelete.isDialogDeleteOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={handleDelete.isDialogDeleteOpen} onClose={handleDelete.handleDeleteCloseDlg} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">
        {t("msgDeleteLogicalUnit", {
          count: handleDelete.selectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {handleDelete.selectedRows().map((row, index, array) => (
          <span key={row.logicalUnitCode} className="inline-block text-gray-800">
            {`${row.logicalUnitCode}`}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U2101LogicalUnitDeleteDlg;
